module.exports = __webpack_public_path__ + "trademark8.png?64553e8f74a248a9bd8a144df9983ae8";


//////////////////
// WEBPACK FOOTER
// ./static/assets/trademark8.png
// module id = 499
// module chunks = 0